import React from 'react'
import { connect } from 'react-redux'
import { Loader } from 'components/UIElements'
import { studiesAction } from '../modules/Studies'
import { actions as studyAction } from '../../routes/CreateStudy/modules/CreateStudy'
import SelectStudyVersionModal from '../components/SelectStudyVersionModal'

const mapState = (state, ownProps) => {
  const { loading, study } = state
  const { studyId } = ownProps
  const studyVersionListStudyId = study.studyVersionListStudyId
  const isStudyVersionListStale = String(studyVersionListStudyId) !== String(studyId)

  return {
    loading: loading.general || loading.studyConfig || isStudyVersionListStale,
    study: study.currentStudy,
    studyVersionList: study.studyVersionList,
    studyVersionTableList: study.studyVersionTableList,
  }
}

export default connect(mapState, { ...studyAction, ...studiesAction })(props => {
  if (props.loading) return <Loader inContainer size={5} />
  return <SelectStudyVersionModal {...props} />
})
